import { APP_BASE_HREF, DOCUMENT } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AccountDataAccessModule } from '@edgvr-front/account/data-access';
import {
  ACCOUNT_ACCESS_REJECTED_URL,
  AccountFeatureAccountAccessModule,
} from '@edgvr-front/account/feature/account-access';
import { ApiDataAccessModule } from '@edgvr-front/api/data-access';
import { BinariesDataAccessModule } from '@edgvr-front/binaries/data-access';
import { COMPANY_BASE_URL } from '@edgvr-front/companies/util/company-url';
import { EdgvrFrontFeatureEnvModule } from '@edgvr-front/edgvr-front/feature/env';
import { EdgvrFrontFeatureTemplateModule } from '@edgvr-front/edgvr-front/feature/template';
import { NotificationsFeatureNotificationsModule } from '@edgvr-front/notifications/feature/notifications';
import { SentryFeatureModule } from '@edgvr-front/sentry/feature';
import { TokenDataAccessModule } from '@edgvr-front/token/data-access';
import { VERSION } from '@edgvr-front/util/version';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    StoreModule.forRoot(
      {},
      {
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
    }),
    TokenDataAccessModule.forRoot({
      domain: environment.domain,
      tokenName: environment.tokenName,
    }),
    ApiDataAccessModule.forRoot({
      apiUrl: environment.apiUrl,
    }),
    AccountDataAccessModule,
    AccountFeatureAccountAccessModule,
    EdgvrFrontFeatureEnvModule.forRoot(environment),
    EdgvrFrontFeatureTemplateModule,
    NotificationsFeatureNotificationsModule,
    SentryFeatureModule.forRoot({
      dsn: environment.sentry.dsn,
      env: environment.sentry.env,
      version: VERSION.raw,
    }),
    AppRoutingModule,
    BinariesDataAccessModule,
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      deps: [DOCUMENT],
      useFactory: (document: Document) => document.location.origin,
    },
    {
      provide: COMPANY_BASE_URL,
      useValue: environment.portalUrl,
    },
    {
      provide: ACCOUNT_ACCESS_REJECTED_URL,
      useValue: environment.frontUrl,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
